// assets
import { SvgClose } from "assets/icons/js/SvgClose";

// style
import "./style.scss";
import { useTheme } from "../ListingTheme";

export const ListingAboutPopup = ({ heading, content, close }: any) => {
	const theme = useTheme();
	return (
		<div
			className="listing__about__popup__container"
			style={{ background: theme?.background }}
		>
			<div className="top">
				<span></span>
				<h2 style={{ color: theme?.primaryTextColor }}>{heading}</h2>
				<span className="close" onClick={close}>
					<SvgClose />
				</span>
			</div>

			<div className="content" style={{ color: theme?.baseTextColor }}>
				{content}
			</div>
		</div>
	);
};
